// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"65923de1","787":"9ee0b182"}[chunkId] + ".chunk.js";
};